import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
})
export class QuoteComponent {
  @Input() quote: IQuote = {
    quote: '',
    background: '',
  };
}

export interface IQuote {
  quote: string;
  background: string;
}
